export default __webpack_public_path__ + "8d28ae4c0c5f909386ba321541f45131.svg";